import { useEffect, useState } from 'react';
import { EngineState } from '../SearchV2.types';

type InitEngineFn = (options: {
  locale: string;
  currency: string;
  analyticsEnabled: boolean;
}) => Promise<unknown>;

export const useEngineState = (
  initFn: InitEngineFn,
  options: { locale: string; currency: string; analyticsEnabled: boolean }
): EngineState => {
  const [engineState, setEngineState] = useState<EngineState>('loading');
  const { locale, currency, analyticsEnabled } = options;

  useEffect(() => {
    let cancelled = false;
    setEngineState('loading');
    initFn({ locale, currency, analyticsEnabled })
      .then(() => {
        if (!cancelled) setEngineState('ready');
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Failed to initialize Coveo engine:', error);
        }
        if (!cancelled) setEngineState('error');
      });
    return () => {
      cancelled = true;
    };
  }, [initFn, locale, currency, analyticsEnabled]);

  return engineState;
};
